







































import Vue from 'vue';
import { Component } from 'vue-property-decorator';

import LoadingBlock from '@/shared/components/LoadingBlock/LoadingBlock.vue';

@Component({
  components: {
    LoadingBlock
  }
})
export default class PaymentLoading extends Vue {
  private zero = 0;
}
